export default "__VITE_ASSET__29a816d8__"